import React, { FC } from 'react'
import classNames from 'classnames'
import { Wrapper } from './Wrapper'

type EmojiProps = {
  onClick: () => void
  active: boolean
  buttonRef: React.RefObject<HTMLButtonElement>
  disabled: boolean
}

const Emoji: FC<EmojiProps> = ({ onClick, active, buttonRef, disabled }) => {
  return (
    <Wrapper
      tabIndex={-1}
      aria-hidden={true}
      onClick={onClick}
      className={classNames('is-double', { 'is-active': active })}
      buttonRef={buttonRef}
      tip={intl.formatMessage({
        id: 'chat / input / emoji',
      })}
      disabled={disabled}
    >
      <span className="far fa-smile" />
      <span className="fa fa-laugh" />
    </Wrapper>
  )
}

export default Emoji
